import { Link } from "react-router-dom";
import { BedDouble, Bath, Ruler } from "lucide-react";
import { STATUS_COLORS, formatPrice, resolveImage } from "../data/site";

const HomeCard = ({ home, tall = false }) => {
  const img = home.images && home.images.length ? resolveImage(home.images[0]) : null;
  return (
    <Link
      to={`/available-homes/${home.id}`}
      data-testid={`home-card-${home.id}`}
      className="group block"
    >
      <div className={`img-zoom relative ${tall ? "aspect-[3/4]" : "aspect-[4/3]"} bg-[#EFECE7]`}>
        {img && (
          <img
            src={img}
            alt={`${home.title} — new construction home in ${home.city || "Idaho"} by On Point Homes`}
            className="w-full h-full object-cover"
            loading="lazy"
          />
        )}
        <span
          data-testid={`home-status-${home.id}`}
          className={`absolute top-4 left-4 font-mono text-[0.6rem] tracking-[0.2em] uppercase font-bold px-3 py-1.5 ${STATUS_COLORS[home.status] || "bg-[#4B4B4B] text-white"}`}
        >
          {home.status}
        </span>
        <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
      </div>
      <div className="pt-5 pb-6 border-b border-[rgba(26,26,26,0.12)]">
        <div className="flex items-baseline justify-between gap-4">
          <h3 className="font-serif text-2xl md:text-3xl tracking-tight text-[#1A1A1A] group-hover:text-[#8C6A4F] transition-colors duration-300">
            {home.title}
          </h3>
          {home.price && <span className="font-mono text-sm font-semibold text-[#1A1A1A] whitespace-nowrap">{formatPrice(home.price)}</span>}
        </div>
        <p className="mt-1 text-sm text-[#5C5A56]">{home.address !== "Coming Soon" ? home.address : ""} {home.city}</p>
        <div className="mt-4 flex items-center gap-5 text-xs font-mono tracking-wider text-[#5C5A56] uppercase">
          {home.beds != null && <span className="flex items-center gap-1.5"><BedDouble size={14} className="text-[#8C6A4F]" /> {home.beds} Bed</span>}
          {home.baths != null && <span className="flex items-center gap-1.5"><Bath size={14} className="text-[#8C6A4F]" /> {home.baths} Bath</span>}
          {home.sqft != null && <span className="flex items-center gap-1.5"><Ruler size={14} className="text-[#8C6A4F]" /> {home.sqft.toLocaleString()} SF</span>}
        </div>
      </div>
    </Link>
  );
};

export default HomeCard;
